// Must come before all mpro modules (will cache the pending callbacks array)
import tempArray from '../mpro/init-globals';
// Import the mpro config method and process the current global config
import '../mpro/config-modules';

// Init the config object and
// collect all pending callbacks from the temp global object
mpro.initNamespace(tempArray);
